import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import Seo from "../components/seo"
import Img from "gatsby-image"
import HeaderLayout from "../components/headerLayout"
import StyledTextSectionClean from "../components/textSectionClean"
import { SRLWrapper } from "simple-react-lightbox";
import SimpleReactLightbox from 'simple-react-lightbox'

const Forprosjekt = () => {
  const data = useStaticQuery(graphql`
    query {
      bilde1: file(relativePath: { eq: "forstehjelp_4.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      bilde2: file(relativePath: { eq: "forprosjekt_bilde1.png" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      bilde3: file(relativePath: { eq: "forprosjekt_bilde2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      bilde4: file(relativePath: { eq: "milestones.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      redbook: file(relativePath: { eq: "redbook.png" }) {
        childImageSharp {
          fixed(width: 200, quality: 100) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      bluebook: file(relativePath: { eq: "bluebook.png" }) {
        childImageSharp {
          fixed(width: 200, quality: 100) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)

  return (
    <>
      <Seo title="Forprosjekt" />
      <HeaderLayout />
      <SimpleReactLightbox>
      <StyledTextSectionClean
        fullWidth
        id="sammenredderviliv"
        header="FORPROSJEKT"
      >
        <p>
          Målet for arbeidet i forprosjektet var å etablere kunnskap om relevant
          og oppdatert forskning, innenfor området førstehjelp for målgruppen
          grunnskoleelever. Deretter evaluere tilgjengelig
          undervisningsmateriell, for til slutt å utvikle et tilpasset
          læremiddel til målgruppen 1-10 klassetrinn.
        </p>
        <p>
          Arbeidet med kunnskapsgrunnlaget ble utført av Sintef, prosjektets
          eksterne evalueringspartner. Deretter ble det etablert en tverrfaglig
          prosjektgruppe med ressurser fra det akuttmedisinske miljøet, et
          utvalg av lærere samt flere prosjektledere fra de andre delprosjektene
          i den nasjonale dugnaden. I tillegg benyttet vi eksterne konsulenter
          innenfor design, film og manusarbeid.{" "}
        </p>
        <SRLWrapper>
        <Img to="Img" fluid={data.bilde4.childImageSharp.fluid} style={{maxWidth: "600px"}} />
        </SRLWrapper>
      </StyledTextSectionClean>
      <StyledTextSectionClean fullWidth>
        <h2>KUNNSKAPSGRUNNLAG</h2>
        <p>
          Arbeidet med kunnskapsgrunnlaget resulterte i en rapport hvor 25
          forskningsartikler ble inkludert. Rapporten trekker ut den viktigste
          kunnskapen som var relevant for utvikling av et læremiddel, for
          livreddende førstehjelp for skolebarn. Hovedkonklusjonen i rapporten
          viser til at alderstilpasset skolebasert opplæring, og trening i
          førstehjelp kan gis til svært unge barn med gode resultater. Rapporten
          viser at:
        </p>
        <ul>
          <li>
            Førstehjelpsopplæring bør baseres på faktakunnskap og praktiske
            øvelser med mål om å øke elevenes selvtillit
          </li>
          <li>Barn og ungdom er villige til å hjelpe andre </li>
          <li>Praksis og motivasjon er grunnleggende for vellykket læring</li>
          <li>
            Virtuelle læringsressurser engasjerer og kan bidra til å øke
            personens tro på egen mestringsevne
          </li>
          <li>
            Opplæringen bør styrke jenters selvtillit til å utføre førstehjelp
          </li>
          <li>
            Opplæringen bør styrke gutters kunnskap om å utføre førstehjelp
            korrekt
          </li>
        </ul>
      </StyledTextSectionClean>
      <StyledTextSectionClean fullWidth>
        <h2>PROSESSEN</h2>
        <p>
          Et mål for forprosjektet var å sikre bred involvering fra fagmiljøene
          innenfor akuttmedisin, oppvekst og skole. Det ble derfor etablert en
          tverrfaglig prosjektgruppe med lærere, ulike ressurser fra de
          akuttmedisinske miljøene, konsulenter og designere. Prosjektgruppen
          kartla og gjennomgikk tilgjengelig førstehjelpslitteratur, ulike typer
          førstehjelpskurs med mer.
        </p>
        <p>
          Dette for å vurdere om det allerede forelå mulige løsninger til bruk i
          utviklingsarbeidet. Arbeidet ble oppsummert og dannet grunnlaget for
          prosjektets beslutning om å lage et nytt læremiddel, med utgangspunkt
          i dugnadens læringsmål, og tilpasse læremiddelet til nye
          kompetansekrav fra Utdanningsdirektoratet.
        </p>
      </StyledTextSectionClean>
      <StyledTextSectionClean fullWidth>
        <h2>LÆREVEILEDNING OG LÆRINGSRESSUSER</h2>
        <p>
          Basert på innsiktsarbeidet og kunnskapsoppsummeringen besluttet
          prosjektet at læremiddelet skulle tilpasses kravene fra
          Utdanningsdirektoratet i ny læreplan fra 2020. En forutsetning i
          utviklingsarbeidet var å sikre at løsningene som ble utviklet
          resulterte i at flest mulig lærere enkelt kunne bruke læremiddelet, og
          at det ble lagt åpent tilgjengelig for alle norske grunnskoler.
        </p>
        <p>
          Læremiddelets innhold skulle baseres på tidskritiske tilstander som
          var identifisert av helsedirektoratet. De besto av:
        </p>
        <ul>
          <li>Bevisstløshet</li>
          <li>Hjertestans</li>
          <li>Hjerteinfarkt</li>
          <li>Hjerneslag</li>
          <li>Skader</li>
        </ul>
        <div className="center-c">
          <Img to="Img" fixed={data.bluebook.childImageSharp.fixed} />
          <Img to="Img" fixed={data.redbook.childImageSharp.fixed} />
        </div>
      </StyledTextSectionClean>
      <StyledTextSectionClean fullWidth>
        <h2>PROSJEKTGRUPPE</h2>
        <p>
          Prosjektgruppen ble satt sammen av et utvalg ressurser fra det
          akuttmedisinske miljøet og lærere fra syv ulike grunnskoler i Norge.
          Arbeidet ble organisert gjennom workshops, telefonmøter og
          epostutvekslinger. Innspillene ble systematisert og sammenfattet
          gjennom tre ulike lærerveiledninger.
        </p>
        <p>
          I arbeidet med produksjonen av læringsressursene deltok elever fra
          flere av de syv skolene og studenter fra TAMS (Tromsø Akuttmedisinske
          Studentforening). I samarbeid med firmaet Designcontainer ble
          læremiddel versjon 1 etablert på nettsiden{" "}
          <a className="link" href="www.førstehjelpigrunnskolen.no.">
            www.førstehjelpigrunnskolen.no.
          </a>{" "}
          Læremiddelet ble lagt fram gratis for skoler og lærere.{" "}
        </p>
        <p>
          Avslutningsvis ble det lagt en plan for pilotperioden sammen med vår
          eksterne evalueringspartner Sintef. Evalueringsarbeidet ble delt inn i
          to ulike faser som videre beskrives i pilotperioden.
        </p>
        <p>Følgende kommuner deltok i utviklingsarbeidet: </p>
        <Img
          alt="Oslo kommune: trasop skole, møllergata skole, st.sunniva private skole. Ullensaker kommune: døli skole. Tromsø Kommune: slettaelva skole, kvaløysletta skole, grønnåsen skole"
          to="img"
          fluid={data.bilde3.childImageSharp.fluid}
          style={{maxWidth: "600px"}}
        />
      </StyledTextSectionClean>
      </SimpleReactLightbox>
    </>
  )
}

export default Forprosjekt
